import { useState } from "react";
import useComponentWidth from "./useComponentWidth.mjs";
import { useIsomorphicLayoutEffect } from "usehooks-ts";
function useComputedCSSGridColumns(deps) {
  const [width, ref] = useComponentWidth();
  const [columns, setColumns] = useState();
  useIsomorphicLayoutEffect(() => {
    if (typeof window === "undefined" || !window.getComputedStyle || !ref.current) {
      return;
    }
    let {
      gridTemplateColumns
    } = window.getComputedStyle(ref.current);
    setColumns(gridTemplateColumns.split(/\s+/g).map(width2 => ({
      width: parseFloat(width2)
    })));
  }, [width, ref.current, ...deps]);
  return [columns, ref];
}
export { useComputedCSSGridColumns as default };